import arrayextensions from './arrayExtensions'
export default {
  install (Vue) {
    Vue.prototype.$extensions = {
      array: arrayextensions
    }
  }
}
